<template>
  <div data-v-46ebc118="" data-v-e5781868="" class=" chess sports messages-box mainContent top50">
    <div data-v-46ebc118="" class="content">
      <div data-v-46ebc118="" class="banner">
        <div data-v-46ebc118="" class="sliderBanner">
          <div data-v-46ebc118="" class="swiper-container swiper swiper-container-horizontal">
            <div class="swiper-wrapper" style="transform: translate3d(-990px, 0px, 0px); transition-duration: 0ms">
              <div data-v-46ebc118="" class="swiper-slide swiper-slide-prev" style="width: 990px">
                <div data-v-46ebc118="" class="banner-img-wrapper"><img data-v-46ebc118="" src="/static/image/banner-sports-012af474b5777aaec59ee140874c00a5f.jpg_.webp" alt="" class="banner-img" /></div>
              </div>
              <!-- <div data-v-46ebc118="" class="swiper-slide swiper-slide-active" style="width: 990px">
                <div data-v-46ebc118="" class="banner-img-wrapper"><img data-v-46ebc118="" src="/static/image/banner-sports-012af474b5777aaec59ee140874c00a5f.jpg_.webp" alt="" class="banner-img" /></div>
              </div>
              <div data-v-46ebc118="" class="swiper-slide swiper-slide-next" style="width: 990px">
                <div data-v-46ebc118="" class="banner-img-wrapper"><img data-v-46ebc118="" src="/static/image/banner-sports-012af474b5777aaec59ee140874c00a5f.jpg_.webp" alt="" class="banner-img" /></div>
              </div> -->
            </div>
            <div data-v-46ebc118="" class="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets">
              <span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide 1"></span>
			  <!-- <span class="swiper-pagination-bullet " tabindex="0" role="button" aria-label="Go to slide 2"></span>
			  <span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide 3"></span> -->
            </div>
            <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
          </div>
        </div>
         <div data-v-46ebc118="" class="menuBox" >
          <a data-v-46ebc118="" class="button button1"  v-for="(item, index) in gameList" :key="index" v-if="  index<3 && item.app_state == 1"
            ><svg data-v-338e1447="" data-v-46ebc118="" aria-hidden="true" class="svg-icon iconBannerPrev">
              <use data-v-338e1447="" xlink:href="#icon-iconBannerPrev"></use>
            </svg>
            <div data-v-46ebc118="" class="inner" v-if='item.app_state == 1'>
              <div data-v-46ebc118="" @click="$parent.openGamePage(item.platform_name, item.game_code, '')" data-hover="立即进厅" class="text"><span data-v-46ebc118="">{{item.name}}</span></div>
            </div> 
             <div data-v-46ebc118="" class="inner" v-else>
              <div data-v-46ebc118=""  data-hover="维护中" class="text"><span data-v-46ebc118="">{{item.name}}</span></div>
            </div> 
            </a
          >
        </div>
        <div data-v-46ebc118="" class="menuBox" v-if="false">
          <a data-v-46ebc118="" class="button button1"
            ><svg data-v-338e1447="" data-v-46ebc118="" aria-hidden="true" class="svg-icon iconBannerPrev">
              <use data-v-338e1447="" xlink:href="#icon-iconBannerPrev"></use>
            </svg>
            <div data-v-46ebc118="" class="inner">
              <div data-v-46ebc118="" @click="$parent.openGamePage('sbtest', '2', '')" data-hover="立即进厅" class="text"><span data-v-46ebc118="">沙巴体育</span></div>
            </div> </a
          ><a data-v-46ebc118="" class="button button1"
            ><svg data-v-338e1447="" data-v-46ebc118="" aria-hidden="true" class="svg-icon iconBannerPrev">
              <use data-v-338e1447="" xlink:href="#icon-iconBannerPrev"></use>
            </svg>
            <div data-v-46ebc118="" class="inner">
              <div data-v-46ebc118="" @click="$parent.openGamePage('oap', '2', '')" data-hover="立即进厅" class="text"><span data-v-46ebc118="">三昇体育</span></div>
            </div> </a
          ><a data-v-46ebc118="" class="button button1"
            ><svg data-v-338e1447="" data-v-46ebc118="" aria-hidden="true" class="svg-icon iconBannerPrev">
              <use data-v-338e1447="" xlink:href="#icon-iconBannerPrev"></use>
            </svg>
            <div data-v-46ebc118="" class="inner">
              <div data-v-46ebc118="" @click="$parent.openGamePage('cmd', '2', '')" data-hover="立即进厅" class="text"><span data-v-46ebc118="">CMD体育</span></div>
            </div>
          </a>
        </div>
      </div>
                <div data-v-50da9dd9="" class="list" >
        <div data-v-50da9dd9="" class="t">
          <svg data-v-338e1447="" data-v-50da9dd9="" aria-hidden="true" class="svg-icon iconThumb">
            <use data-v-338e1447="" xlink:href="#icon-iconThumb"></use>
          </svg>
          热门体育
          <div data-v-50da9dd9="" class="tools">
            <span data-v-50da9dd9="" slot="button-prev" class="item swiper-button-prev swiper-button-disabled" tabindex="0" role="button" aria-label="Previous slide" aria-disabled="true"
              ><svg data-v-338e1447="" data-v-50da9dd9="" aria-hidden="true" class="svg-icon icon iconArrowLeft">
                <use data-v-338e1447="" xlink:href="#icon-iconArrowLeft"></use></svg></span
            ><span data-v-50da9dd9="" slot="button-next" class="item swiper-button-next swiper-button-disabled" tabindex="0" role="button" aria-label="Next slide" aria-disabled="true"
              ><svg data-v-338e1447="" data-v-50da9dd9="" aria-hidden="true" class="svg-icon icon iconArrowRight">
                <use data-v-338e1447="" xlink:href="#icon-iconArrowRight"></use></svg
            ></span>
          </div>
        </div>
        <div data-v-50da9dd9="" class="c">
          <div data-v-50da9dd9="" class="swiper-container swiper swiper-container-horizontal">
            <div class="swiper-wrapper" style="transform: translate3d(0px, 0px, 0px)">
              <div data-v-50da9dd9="" class="swiper-slide" style="width: 317.5px; margin-right: 20px" v-for="(item, index) in gameList" :key="index" v-if="index>=3 && item.app_state == 1">
                <div data-v-50da9dd9="" class="item">
                  <div data-v-50da9dd9="" class="img">
                    <img data-v-50da9dd9="" :src="`/static/image/sport/${item.platform_name}ty.png`" />

                    <div data-v-50da9dd9="" class="mask" style="display: none"><img data-v-50da9dd9="" src="/static/image/maintain.b2eb4b18.png" class="maintain" /><span data-v-50da9dd9="" class="t">游戏维护中</span></div>
                  </div>
                  <div data-v-50da9dd9="" class="info" v-if="item.app_state == 1">
                    <h3 data-v-50da9dd9="">{{item.name}}</h3>
                    <a data-v-50da9dd9="" class="button buttonBordered" @click="$parent.openGamePage(item.platform_name, item.game_code, '')"
                      >快速游戏
                      <svg data-v-338e1447="" data-v-50da9dd9="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                      <div data-v-50da9dd9="" class="info" v-else>
                    <h3 data-v-50da9dd9="">{{item.name}}</h3>
                    <a data-v-50da9dd9="" class="button buttonBordered" 
                      >维护中
                      <svg data-v-338e1447="" data-v-50da9dd9="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div>
             
            </div>
            <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span><span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
          </div>
        </div>
      </div>
           <div data-v-50da9dd9="" class="list" v-if="false">
        <div data-v-50da9dd9="" class="t">
          <svg data-v-338e1447="" data-v-50da9dd9="" aria-hidden="true" class="svg-icon iconThumb">
            <use data-v-338e1447="" xlink:href="#icon-iconThumb"></use>
          </svg>
          热门体育
          <div data-v-50da9dd9="" class="tools">
            <span data-v-50da9dd9="" slot="button-prev" class="item swiper-button-prev swiper-button-disabled" tabindex="0" role="button" aria-label="Previous slide" aria-disabled="true"
              ><svg data-v-338e1447="" data-v-50da9dd9="" aria-hidden="true" class="svg-icon icon iconArrowLeft">
                <use data-v-338e1447="" xlink:href="#icon-iconArrowLeft"></use></svg></span
            ><span data-v-50da9dd9="" slot="button-next" class="item swiper-button-next swiper-button-disabled" tabindex="0" role="button" aria-label="Next slide" aria-disabled="true"
              ><svg data-v-338e1447="" data-v-50da9dd9="" aria-hidden="true" class="svg-icon icon iconArrowRight">
                <use data-v-338e1447="" xlink:href="#icon-iconArrowRight"></use></svg
            ></span>
          </div>
        </div>
        <div data-v-50da9dd9="" class="c">
          <div data-v-50da9dd9="" class="swiper-container swiper swiper-container-horizontal">
            <div class="swiper-wrapper" style="transform: translate3d(0px, 0px, 0px)">
              <!-- 沙巴 -->
              <!-- <div data-v-50da9dd9="" class="swiper-slide swiper-slide-active" style="width: 317.5px; margin-right: 20px">
                <div data-v-50da9dd9="" class="item">
                  <div data-v-50da9dd9="" class="img">
                    <img data-v-50da9dd9="" src="/static/image/imageTiyuBs.png" />
                    <div data-v-50da9dd9="" class="mask" style="display: none"><img data-v-50da9dd9="" src="/static/image/maintain.b2eb4b18.png" class="maintain" style="display: none" /><span data-v-50da9dd9="" class="t" style="display: none">游戏维护中</span></div>
                  </div>
                  <div data-v-50da9dd9="" class="info">
                    <h3 data-v-50da9dd9="">沙巴体育</h3>
                    <a data-v-50da9dd9="" class="button buttonBordered"  @click="$parent.openGamePage('sbtest', '2', '')" 
                      >快速游戏
                      <svg data-v-338e1447="" data-v-50da9dd9="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div> -->
              <!-- 三昇体育 -->
              <!-- <div data-v-50da9dd9="" class="swiper-slide swiper-slide-next" style="width: 317.5px; margin-right: 20px">
                <div data-v-50da9dd9="" class="item">
                  <div data-v-50da9dd9="" class="img">
                    <img data-v-50da9dd9="" src="/static/image/imageTiyuBs.png" />

                    <div data-v-50da9dd9="" class="mask" style="display: none" ><img data-v-50da9dd9="" src="/static/image/maintain.b2eb4b18.png" class="maintain" style="display: none" /><span data-v-50da9dd9="" class="t" style="display: none">游戏维护中</span></div>
                  </div>
                  <div data-v-50da9dd9="" class="info">
                    <h3 data-v-50da9dd9="">三昇体育</h3>
                    <a data-v-50da9dd9="" class="button buttonBordered" @click="$parent.openGamePage('oap', '2', '')" 
                      >快速游戏
                      <svg data-v-338e1447="" data-v-50da9dd9="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div> -->
              <!-- CMD体育 -->
              <!-- <div data-v-50da9dd9="" class="swiper-slide" style="width: 317.5px; margin-right: 20px">
                <div data-v-50da9dd9="" class="item">
                  <div data-v-50da9dd9="" class="img">
                    <img data-v-50da9dd9="" src="/static/image/imageTiyuBs.png" />

                    <div data-v-50da9dd9="" class="mask" style="display: none" ><img data-v-50da9dd9="" src="/static/image/maintain.b2eb4b18.png" class="maintain" style="display: none" /><span data-v-50da9dd9="" class="t" style="display: none">游戏维护中</span></div>
                  </div>
                  <div data-v-50da9dd9="" class="info">
                    <h3 data-v-50da9dd9="">CMD体育</h3>
                    <a data-v-50da9dd9="" class="button buttonBordered" @click="$parent.openGamePage('cmd', '2', '')"
                      >快速游戏
                      <svg data-v-338e1447="" data-v-50da9dd9="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div> -->
              <!-- ASIA体育 -->
              <div data-v-50da9dd9="" class="swiper-slide" style="width: 317.5px; margin-right: 20px">
                <div data-v-50da9dd9="" class="item">
                  <div data-v-50da9dd9="" class="img">
                    <img data-v-50da9dd9="" src="/static/image/imageTiyuBs.png" />

                    <div data-v-50da9dd9="" class="mask" style="display: none"><img data-v-50da9dd9="" src="/static/image/maintain.b2eb4b18.png" class="maintain" /><span data-v-50da9dd9="" class="t">游戏维护中</span></div>
                  </div>
                  <div data-v-50da9dd9="" class="info">
                    <h3 data-v-50da9dd9="">ASIA体育</h3>
                    <a data-v-50da9dd9="" class="button buttonBordered" @click="$parent.openGamePage('hbb', '2', '')"
                      >快速游戏
                      <svg data-v-338e1447="" data-v-50da9dd9="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div>
              <!-- TG体育 -->
              <div data-v-50da9dd9="" class="swiper-slide" style="width: 317.5px; margin-right: 20px">
                <div data-v-50da9dd9="" class="item">
                  <div data-v-50da9dd9="" class="img">
                    <img data-v-50da9dd9="" src="/static/image/imageTiyuBs.png" />
                    
                    <div data-v-50da9dd9="" class="mask" style="display: none"><img data-v-50da9dd9="" src="/static/image/maintain.b2eb4b18.png" class="maintain" /><span data-v-50da9dd9="" class="t">游戏维护中</span></div>
                  </div>
                  <div data-v-50da9dd9="" class="info">
                    <h3 data-v-50da9dd9="">TG体育</h3>
                    <a data-v-50da9dd9="" class="button buttonBordered"  @click="$parent.openGamePage('saba', '2', '')"
                      >快速游戏
                      <svg data-v-338e1447="" data-v-50da9dd9="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div>
      
              <!-- SBO体育 -->
              <div data-v-50da9dd9="" class="swiper-slide" style="width: 317.5px; margin-right: 20px">
                <div data-v-50da9dd9="" class="item">
                  <div data-v-50da9dd9="" class="img">
                    <img data-v-50da9dd9="" src="/static/image/imageTiyuBs.png" />

                    <div data-v-50da9dd9="" class="mask" style="display: none"><img data-v-50da9dd9="" src="/static/image/maintain.b2eb4b18.png" class="maintain" /><span data-v-50da9dd9="" class="t">游戏维护中</span></div>
                  </div>
                  <div data-v-50da9dd9="" class="info">
                    <h3 data-v-50da9dd9="">SBO体育</h3>
                    <a data-v-50da9dd9="" class="button buttonBordered"  @click="$parent.openGamePage('xsbo', '2', '')" 
                      >快速游戏
                      <svg data-v-338e1447="" data-v-50da9dd9="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div>
              <!-- OB体育 -->
              <div data-v-50da9dd9="" class="swiper-slide" style="width: 317.5px; margin-right: 20px">
                <div data-v-50da9dd9="" class="item">
                  <div data-v-50da9dd9="" class="img">
                    <img data-v-50da9dd9="" src="/static/image/imageTiyuBs.png" />

                    <div data-v-50da9dd9="" class="mask" style="display: none"><img data-v-50da9dd9="" src="/static/image/maintain.b2eb4b18.png" class="maintain" /><span data-v-50da9dd9="" class="t">游戏维护中</span></div>
                  </div>
                  <div data-v-50da9dd9="" class="info">
                    <h3 data-v-50da9dd9="">OB体育</h3>
                    <a data-v-50da9dd9="" class="button buttonBordered" @click="$parent.openGamePage('obgty', '2', '')"
                      >快速游戏
                      <svg data-v-338e1447="" data-v-50da9dd9="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div>

              <!-- BBIN体育 -->
              <div data-v-50da9dd9="" class="swiper-slide" style="width: 317.5px; margin-right: 20px">
                <div data-v-50da9dd9="" class="item">
                  <div data-v-50da9dd9="" class="img">
                    <img data-v-50da9dd9="" src="/static/image/imageTiyuBs.png" />

                    <div data-v-50da9dd9="" class="mask" style="display: none"><img data-v-50da9dd9="" src="/static/image/maintain.b2eb4b18.png" class="maintain" /><span data-v-50da9dd9="" class="t">游戏维护中</span></div>
                  </div>
                  <div data-v-50da9dd9="" class="info">
                    <h3 data-v-50da9dd9="">BBIN体育</h3>
                    <a data-v-50da9dd9="" class="button buttonBordered" @click="$parent.openGamePage('bbin', 'bbinpe', '')"
                      >快速游戏
                      <svg data-v-338e1447="" data-v-50da9dd9="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div>
             
            </div>
            <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span><span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
          </div>
        </div>
      </div>
      <
    </div>
  </div>
</template>
<script>
export default {
  name: 'sports',
  data() {
    return {gameList:[]};
  },
  created() {
    let that = this;
    that.getGameList();

  },
  methods: {
            getGameList() {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun.get('/api/game/list', { category: 'sport' }).then(res => {
        if (res.code == 200) {
          that.gameList = res.data;
        }
        that.$parent.hideLoading();
      });
    },
    //弹出登录框
    loginBox() {
      console.log($('.mask'));
      $('.mask').fadeOut(300);
      $('.mask.login').fadeIn(300);
    },
    //弹出注册框
    registerBox() {
      $('.mask').fadeOut(300);
      $('.mask.register').fadeIn(300);
    },
    //弹出忘记密码框
    forgetBox() {
      $('.mask').fadeOut(300);
      $('.mask.forget').fadeIn(300);
    },
  },
  mounted() {
    let that = this;
 
	//soprt-banner

  },
  updated() {
    let that = this;
    var gameSwipper = new Swiper('.sliderBanner .swiper', {
	autoplay: {
		delay: 3000,
		stopOnLastSlide: false,
		disableOnInteraction: true,
    },
	pagination: {
		el: '.sliderBanner .swiper-pagination',
		clickable: true,
	},
});

//投注类型tab切换
$('.controls span').click(function() {
	$(this).addClass('active').siblings().removeClass('active');
});
//选择胜负平tab切换
$('.ysb-item__body__odds .ysb-item__body__odds__item').click(function() {
	$(this).addClass('ysb-item__body__odds__item--active').siblings().removeClass('ysb-item__body__odds__item--active');
});
    var listSwipper = new Swiper('.swiper', {
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: true,
      },
      slidesPerView: 4,
      spaceBetween: 20,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/chunk-118cf728.cc19700a.css';
.swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 0 0.04rem;
}

@import '../../../static/css/chunk-70b6a91e.6c8f8470.css';



.chess .list .c .item .img {
    width: 100%;
    height: 2rem;
}
.chess .list .c[data-v-50da9dd9][data-v-2bea8bea] {
    padding-bottom: 80px;
}
.chess .list[data-v-50da9dd9][data-v-2bea8bea] {
    padding-top: 0!important;
}
.chess .list {
     padding-top: 0!important;
}
.chess .list .t {
    text-align: left!important;;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/sports.vue